import React, { useContext, useState } from "react";
import { AccountContext } from '../../../Contexts/main.context';

const CitationUploader = () => {
     const context = useContext(AccountContext);
     const { activeClient } = context || {};
     const [uploadMessage, setUploadMessage] = useState("");
     const [returnData, setReturnData] = useState(null);



     const [file, setFile] = useState(null);



     const handleFileChange = (e) => {
          setFile(e.target.files[0]);
     };

     const handleSubmit = async (e) => {
          e.preventDefault();
          if (!file) return alert("Please select a CSV file.");

          const formPayload = new FormData();
          formPayload.append("citationFile", file);
          formPayload.append("clientID", activeClient?.ID || 0);
          formPayload.append("companyName", activeClient?.companyName || '');
          const today = new Date();
          const year = today.getFullYear();
          const month = today.getMonth() + 1; // JS months are 0-based
          const day = today.getDate();
          formPayload.append("year", year);
          formPayload.append("month", month);
          formPayload.append("day", day);


          setUploadMessage("Uploading...");

          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/upload_citation.php", {
                    method: "POST",
                    body: formPayload,
               });

               const result = await response.json();
               console.log("Server Response:", result);
               setUploadMessage('Back');
               setReturnData(result);
          } catch (err) {
               console.error(err);
               setUploadMessage("Upload failed. Please try again.");
          }
     };

     return (
          <div className="container">
               <div className="justify-content-center p-4 fs-5 fw-bold mb-2 alert-dark d-flex">
                    <div>
                         Current Location - {activeClient.companyName} - {activeClient.city}
                    </div>
               </div>
               <div className="alert bg-navy text-white p-3 rounded">
                    <strong>Instructions:</strong> Please upload a <span className="text-lemon">.csv</span> file information:
                    <ul className="mt-2 mb-0">
                         <li><strong>1</strong> → Open the File from Citation Group</li>
                         <li><strong>2</strong> → Remove the top 10 lines that has logo etc.</li>
                         <li><strong>3</strong> → Remove the Header Line</li>
                         <li><strong>4</strong> → Remove the Number Line</li>
                         <li><strong>5</strong> → Remove any Citations that are Pending</li>
                         <li><strong>6</strong> → There should be 7 Columns</li>
                    </ul>
                    <div className="fw-bold text-lemon mt-3 text-center">
                         This will upload your Data and search for duplicates, No need to check these yourself.
                    </div>
               </div>

               <form onSubmit={handleSubmit} className="border p-4 rounded shadow-sm bg-light">
                    <div className="mb-3">
                         <label htmlFor="citationFile" className="form-label fw-bold">
                              Select Citation CSV File:
                         </label>

                         {/* CSV File Input */}
                         <div className="col-48">
                              <input
                                   type="file"
                                   name="citationFile"
                                   id="citationFile"
                                   accept=".csv"
                                   className="form-control"
                                   onChange={handleFileChange}
                                   required
                              />
                         </div>
                    </div>

                    <div className="col-48 d-flex justify-content-center">
                         <button type="submit" className="btn btn-success text-light fw-bold px-5 mt-3">
                              Upload
                         </button>
                    </div>
               </form>


               {uploadMessage && (
                    <div className="alert alert-info mt-3">
                         <div className="col-48 text-center fw-bold h3">File Uploaded</div>

                         <div className="d-flex justify-content-around mt-3">
                              <div className="col-22 text-center">New Records: {returnData?.newCount ?? 0}</div>
                              <div className="col-22 text-center">Existing/Pending: {returnData?.existCount ?? 0}</div>
                         </div>

                         {Array.isArray(returnData?.existing) && returnData.existing.length > 0 && (
                              <div className="mt-3">
                                   <div className="fw-bold mb-2">Existing domains:</div>
                                   {returnData.existing.map((d, i) => (
                                        <div key={`${d}-${i}`} className="small">{d}</div>
                                   ))}
                              </div>
                         )}
                    </div>
               )}

          </div>
     );
};

export default CitationUploader;
